module.exports = __webpack_public_path__ + "static/Srilanka-logo-734b70aeef1f7a9489c5ed9916d83207.png";